import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import Header from "../../Components/Common/Header";
import { StoreOutlined } from "@mui/icons-material";
import BannerImageSlider from "../../Components/Store/BannerImageSlider";
import { colors } from "../../theme/theme";
import SimilarProductCard from "../../Components/Product/SimilarProductCard";
import { menProducts, storeWomenProducts } from "../../assets/dummyData";
import Footer from "../../Components/Common/Footer";
import SearchBox from "../../Components/Search/SearchBox";

const Store = () => {
  const [search, setSearch] = useState("");

  const brandLogos = [
    { id: 1, image: require("../../assets/icons/paradox.png") },
    { id: 2, image: require("../../assets/icons/sapphire.png") },
    { id: 3, image: require("../../assets/icons/maria.b.png") },
    { id: 4, image: require("../../assets/icons/ss.png") },
    { id: 5, image: require("../../assets/icons/ss.png") },
    { id: 5, image: require("../../assets/icons/ss.png") },
    { id: 5, image: require("../../assets/icons/ss.png") },
  ];
  return (
    <Box sx={{ backgroundColor: "#f6f3f0" }}>
      <Header />

      {/* Search Box */}
      <SearchBox search={search} setSearch={setSearch} />

      {/* Address */}
      <Stack direction="row" sx={{ mx: 2, mt: 3, alignItems: "center" }}>
        <StoreOutlined sx={{ color: "#1B1211" }} />
        <Typography
          sx={{
            color: "#1B1211",
            ml: 1,
            fontFamily: "Poppins-Medium",
            fontSize: "12px",
          }}
        >
          shop no. 504 3rd floor luckyone mall{" "}
        </Typography>
      </Stack>

      {/* Brands Slider */}
      <Box
        sx={{
          display: "flex",
          overflowX: "auto",
          whiteSpace: "nowrap",
          mt: 2,
          width: "100%",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {brandLogos.map((logo, index) => (
          <Box
            sx={{
              px: 2,
              py: 1,
              display: "inline-block",
              ml: index === 0 ? 2 : 0,
              flexShrink: 0,
            }}
            key={index}
          >
            <img
              src={logo.image}
              style={{ width: "150px", height: "auto" }}
              alt="logo"
            />
          </Box>
        ))}
      </Box>

      {/* Slider */}
      <BannerImageSlider />

      {/* Suggested Men Products */}
      <Box
        sx={{
          borderTopLeftRadius: "20px",
          borderBottomLeftRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "-1px -2px 15px 0px #00000012",
          ml: 2,
          mb: 2,
          mt: 4,
          overflowX: "visible",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins-Bold",
            fontSize: "20px",
            color: colors.textColor,
            mx: 2,
            py: 2,
          }}
        >
          Mens Collection
        </Typography>

        <SimilarProductCard productData={menProducts} noColor />
      </Box>

      {/* Suggested Women Products */}
      <Box
        sx={{
          borderTopLeftRadius: "20px",
          borderBottomLeftRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "-1px -2px 15px 0px #00000012",
          ml: 2,
          mb: 2,
          mt: 4,
          overflowX: "visible",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins-Bold",
            fontSize: "20px",
            color: colors.textColor,
            mx: 2,
            py: 2,
          }}
        >
          Womens Collection
        </Typography>

        <SimilarProductCard productData={storeWomenProducts} noColor />
      </Box>

      <Footer />
    </Box>
  );
};

export default Store;
